// src/lib/custom-instance.ts

import { config } from "@/config";
import { getToken } from "@/services/utils";
import Axios, { type AxiosError, type AxiosRequestConfig } from "axios";

export const AXIOS_INSTANCE = Axios.create({
  baseURL: config?.BACKEND_URL || "",
  timeout: 30_000,
  headers: { "Content-Type": "application/json" },
});

AXIOS_INSTANCE.interceptors.request.use(
  async (cfg) => {
    const token = await getToken();
    if (token) cfg.headers!["Authorization"] = `Bearer ${token}`;
    return cfg;
  },
  (error) => Promise.reject(error),
);

AXIOS_INSTANCE.interceptors.response.use(
  (res) => res,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      console.error("Token inválido o expirado");
      // aquí podrías redirigir o refrescar
    }
    if (error.response?.status === 500) {
      console.error("Error interno del servidor");
    }
    return Promise.reject(error);
  },
);

/**
 * Función que Orval invocará.
 * @param cfg Configuración de la petición
 * @returns La propiedad `data` del response
 */
export function customInstance<T = any>(cfg: AxiosRequestConfig): Promise<T> {
  return AXIOS_INSTANCE(cfg).then((res) => res.data as T);
}
